import React, { useState } from "react";

type GroupContextType = {
  headerRowId: string;
  setHeaderRowId: React.Dispatch<React.SetStateAction<string>>;
};

export const GroupContext = React.createContext<GroupContextType | undefined>(
  undefined
);

type GroupContextProps = {
  children: React.ReactNode;
};

export const GroupProvider = ({ children }: GroupContextProps): JSX.Element => {
  const [headerRowId, setHeaderRowId] = useState<string>("");

  const value = { headerRowId, setHeaderRowId };
  return (
    <GroupContext.Provider value={value}>{children}</GroupContext.Provider>
  );
};

export const useGroup = (): GroupContextType => {
  const context = React.useContext(GroupContext);

  if (context === undefined) {
    return {
      headerRowId: "",
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      setHeaderRowId: (() => {}) as React.Dispatch<
        React.SetStateAction<string>
      >,
    };
  }

  return context;
};
